import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import wb from "./registerServiceWorker";
import VueCurrencyFilter from "vue-currency-filter";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import "../public/assets/css/citridia.css";
import Vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
// import VueHtml2Canvas from "vue-html2canvas";
import VueCountryCode from "vue-country-code";
import moment from "moment-timezone";
import { registerModules } from "@/register-modules";
import helpers from "./helpers/helpers";
import store from "./store";
import PullToRefresh from "pulltorefreshjs";
import VCalendar from 'v-calendar';
// import VueSocketIO from "vue-socket.io";
// import SocketIO from "socket.io-client";
import { sockets } from "./config/socketService";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$baseurl = process.env.VUE_APP_API_URL;
let ROOT = process.env.VUE_APP_API_URL;
Vue.prototype.$workbox = wb;
Vue.use(VueCurrencyFilter, {
  symbol: "Rp ",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: false,
});
Vue.use(VueToast, {
  position: "top",
  duration: 10000,
});
Vue.use(Vuelidate);

Vue.filter("decimal", function (angka) {
  var number_string = angka.toString().replace(/[^.\d]/g, ""),
    split = number_string.split("."),
    sisa = split[0].length % 3,
    desimal = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
  if (ribuan) {
    var separator = sisa ? "." : "";
    desimal += separator + ribuan.join(".");
  }

  desimal = split[1] != undefined ? desimal + "," + split[1] : desimal;
  return desimal;
});

// Vue.use(VueHtml2Canvas);
Vue.use(VueCountryCode);

const P1_MASTERDATA = ROOT + "masterData/";
const P1_META = ROOT + "meta/";

const P2_KARYAWAN = P1_MASTERDATA + "karyawan/";

Vue.prototype.$CEK_USERNAME_KARYAWAN = P2_KARYAWAN + "cek_username_karyawan";

Vue.prototype.$template_import_layanan_url =
  "https://storage.googleapis.com/ember-e-dalbo/bos_revamp/master_template_excel/template_data_layanan.xlsx";
Vue.prototype.$template_import_layanan_snap_url =
  "https://storage.googleapis.com/ember-e-dalbo/bos_revamp/master_template_excel/template_data_layanan_snapclean.xlsx";
Vue.prototype.$template_import_absensi_url =
  "https://storage.googleapis.com/ember-e-dalbo/bos_revamp/master_template_excel/template_data_absensi.xlsx";

Vue.prototype.$catch_error_response = (e) => {
  if (e.response) {
    Vue.$toast.error(
      "response: " +
        e.response.data.msg +
        ". Lebih lanjut hubungi cs kami di nomor 6285234494494"
    );
  } else if (e.request) {
    Vue.$toast.error(
      "request: " + e + ". Lebih lanjut hubungi cs kami di nomor 6285234494494"
    );
  } else {
    // Vue.$toast.error("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti")
    Vue.$toast.error(
      "local: " + e + ". Lebih lanjut hubungi cs kami di nomor 6285234494494"
    );
  }
};
moment.locale("id");
Vue.prototype.$moment = moment;

const gmapKey = "AIzaSyDtRrd_eOC7JXO7nBHiEBlBx2kiut58UCU";
Vue.prototype.$gmapKey = gmapKey;
Vue.use(VueGoogleMaps, {
  load: {
    key: gmapKey,
    libraries: "places",
  },
});

Vue.use(VCalendar, {
  componentPrefix: 'sm',
});

Vue.component("v-select", vSelect);


// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: SocketIO(process.env.VUE_APP_SOCKET_URL, {transports: ['websocket']}), //options object is Optional
//     vuex: {
//         store,
//         actionPrefix: "SOCKET_",
//         mutationPrefix: "SOCKET_"
//     }
// }))

registerModules();

PullToRefresh.init({
  mainElement: "body",
  distThreshold: 145,
  distMax: 150,
  distIgnore: 80,
  onRefresh() {
    window.location.reload();
  },
});

new Vue({
  router,
  render: (h) => h(App),
  store,
  mixins: [Vue.mixin(helpers)],
}).$mount("#app");
